var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.676,
    height: 256.017,
    viewBox: "0 0 138.676 256.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Generic_Mobile_Phone-100",
    "data-name": "Generic Mobile Phone-100",
    d: "M28,1A16.083,16.083,0,0,0,12,17V241.016a16.083,16.083,0,0,0,16,16H134.675a16.083,16.083,0,0,0,16-16V17a16.083,16.083,0,0,0-16-16Zm0,10.667H134.675A5.249,5.249,0,0,1,140.008,17V241.016a5.249,5.249,0,0,1-5.334,5.334H28a5.249,5.249,0,0,1-5.334-5.334V17A5.249,5.249,0,0,1,28,11.667ZM81.338,22.335a5.334,5.334,0,1,0,5.334,5.334A5.334,5.334,0,0,0,81.338,22.335Z",
    transform: "translate(-12 -1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.efb475eba747611e5bbc808836aa8c36.svg";
export { ForwardRef as ReactComponent };